__turbopack_context__.v({
  "appSearchResultItem": "Rol-vG_appSearchResultItem",
  "appSearchResultItemButton": "Rol-vG_appSearchResultItemButton",
  "appSearchResultItemFlag": "Rol-vG_appSearchResultItemFlag",
  "appSearchResultItemImage": "Rol-vG_appSearchResultItemImage",
  "appSearchResultItemMobileHide": "Rol-vG_appSearchResultItemMobileHide",
  "appSearchResultItemTabletHide": "Rol-vG_appSearchResultItemTabletHide",
  "appSearchResultItemText": "Rol-vG_appSearchResultItemText",
  "appSearchResultItemTitle": "Rol-vG_appSearchResultItemTitle",
  "appSearchResultItemTop": "Rol-vG_appSearchResultItemTop",
  "appSearchResultItemTopText": "Rol-vG_appSearchResultItemTopText",
  "appSearchResultItemType": "Rol-vG_appSearchResultItemType",
  "flagIcon": "Rol-vG_flagIcon",
  "imageWrapper": "Rol-vG_imageWrapper",
});
